<template>
  <VChip
    :text="text"
    :color="variant === 'custom' ? '#206583' : '#414651'"
    :class="[
      '!text-sm gap-1',
      { 'font-semibold': textBold },
      variant !== 'custom' ? 'bg-[#FAFAFA] text-[#414651] border-[#E9EAEB]' : ''
    ]"
    :disabled="disabled"
    variant="outlined"
    size="small"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>

    <template #close v-if="removable">
      <VIcon :icon="'close'" density="compact" />
    </template>
  </VChip>
</template>

<script setup lang="ts">
import type { ChipVariant } from '@/hospitalAdminTool/types/ChipVariant'

interface Props {
  text: string
  textBold?: boolean
  removable?: boolean
  variant?: ChipVariant
  disabled?: boolean
}

defineProps<Props>()
</script>

<style scoped></style>
